<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="500px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <span class="edit-button" slot="activator">edit</span>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Edit business details</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <span class="done-button" @click="onSaveChanges" v-if='valid'>done</span>
            <span class="done-button disabled" v-if='!valid'>done</span>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex >
            <v-text-field
              name="groupTitle"
              label="Your business name"
              id="groupTitle"
              v-model="addedgroupTitle"
              type="text"
              autofocus
              ref="focus"
              placeholder=" "
              :rules="[input_required]"
              required></v-text-field>
          </v-flex>
          <v-flex>
            <address-fields
              :companyAddress.sync="addedgroupAddress"
              :groupAddress1.sync="addedgroupAddress1"
              :groupAddress2.sync="addedgroupAddress2"
              :groupCityRegion.sync="addedgroupCityRegion"
              :groupCountyState.sync="addedgroupCountyState"
              :groupPostcode.sync="addedgroupPostcode"
              :groupCountry.sync="addedgroupCountry"
            ></address-fields>
          </v-flex>
          <v-flex>
            <v-checkbox
              label="Save as the default for all future invoices and quotes"
              v-model="saveAsDefault"
              ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import AddressFields from '@/components/Shared/AddressFields'

export default {
  name: 'EditBusinessDetailsModal',
  components: {
    AddressFields
  },
  props: {
    invoice: Object
  },
  data () {
    return {
      valid: false,
      showDialog: false,
      saveAsDefault: true,
      addedgroupTitle: this.invoice.groupTitle,
      addedgroupAddress: this.invoice.groupAddress,
      addedgroupAddress1: this.invoice.groupAddress1,
      addedgroupAddress2: this.invoice.groupAddress2,
      addedgroupCityRegion: this.invoice.groupCityRegion,
      addedgroupCountyState: this.invoice.groupCountyState,
      addedgroupPostcode: this.invoice.groupPostcode,
      addedgroupCountry: this.invoice.groupCountry,
      groupId: this.$store.getters.user.group,
      input_required: value => !!value || 'Required.'
    }
  },
  watch: {
    showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    onSaveChanges () {
      // quick check to ensure the title is here
      if (this.addedgroupTitle.trim() === '') {
        return
      }
      // return these details to the invocie component
      this.$emit('return-business-details', {
        groupTitle: this.addedgroupTitle,
        groupAddress: this.addedgroupAddress,
        groupAddress1: this.addedgroupAddress1,
        groupAddress2: this.addedgroupAddress2,
        groupCityRegion: this.addedgroupCityRegion,
        groupCountyState: this.addedgroupCountyState,
        groupPostcode: this.addedgroupPostcode,
        groupCountry: this.addedgroupCountry
      })
      // If we are setting these as default save them to FB which will push them to the store for us.
      if (this.saveAsDefault === true) {
        // Make the update object
        const groupUpdate = {
          title: this.addedgroupTitle,
          companyAddress: this.addedgroupAddress,
          groupAddress1: this.addedgroupAddress1,
          groupAddress2: this.addedgroupAddress2,
          groupCityRegion: this.addedgroupCityRegion,
          groupCountyState: this.addedgroupCountyState,
          groupPostcode: this.addedgroupPostcode,
          groupCountry: this.addedgroupCountry
        }
        // save object to FB
        firebase.database().ref('groups').child(this.groupId).update(groupUpdate)
          .then(() => {
            this.$store.commit('setLoading', false)
          })
          .catch(error => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          })
      }
      this.showDialog = false
    },
    toggleDialog () {
      this.showDialog = !this.showDialog
    }
  }

}
</script>
